<template>
  <div class="empty-state-wrapper text-center py-5 px-3" :class="{ 'compact-mode': compact }">
    <div
      class="empty-state-icon-container mb-3 mx-auto d-flex align-items-center justify-content-center"
      :style="{ width: compact ? '48px' : '64px', height: compact ? '48px' : '64px' }"
    >
      <i :class="['mdi', icon]" :style="{ fontSize: compact ? '1.5rem' : '2rem' }"></i>
    </div>
    <h5 class="text-white font-weight-semibold mb-1" :style="{ fontSize: compact ? '0.9rem' : '1.05rem', letterSpacing: '-0.02em' }">
      {{ title || $t('common.noData') }}
    </h5>
    <p class="text-muted mb-4 mx-auto" :style="{ maxWidth: '420px', fontSize: compact ? '0.8rem' : '0.875rem', lineHeight: '1.5' }">
      {{ description || ($currentLocale === 'id' ? 'Belum ada data untuk ditampilkan saat ini.' : 'There are no records to display at the moment.') }}
    </p>
    <div v-if="actionText && actionTo">
      <router-link :to="actionTo" class="btn btn-primary btn-sm">
        <i :class="['mdi', actionIcon, 'mr-1']"></i> {{ actionText }}
      </router-link>
    </div>
    <slot name="action"></slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: {
      type: String,
      default: 'mdi-inbox-outline',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    actionText: {
      type: String,
      default: '',
    },
    actionTo: {
      type: [String, Object],
      default: null,
    },
    actionIcon: {
      type: String,
      default: 'mdi-plus',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.empty-state-wrapper {
  background: rgba(255, 255, 255, 0.015);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  margin: 0.5rem 0;
}
.empty-state-icon-container {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  color: #9da1b2;
}
</style>
